import React, { useState, useEffect } from 'react'
import { Full as Loading } from 'components/Loading'
import { FormattedMessage, useIntl } from 'react-intl'

import Template from './../../components/Template'

import OrderDetailsPane from 'containers/CustomerOrdersPage/components/OrderDetailsPane'
import messages from './messages'

const UpdatePage = ({ match: { params: { id } } }) => {
  const [template, setTemplate] = useState(null)
  const [lastChange, setLastChange] = useState(+Date.now())

  useEffect(() => {
    if (id) {
      fetchTemplate()
    }
  }, [])

  const fetchTemplate = () => {
    fetch(`/rest/v2/order/${id}/fetch`, { credentials: 'same-origin' })
      .then((response) => response.json())
      .then(({ errors, success, data, meta }) => {
        if (success) {
          setTemplate(data)
        } else {
          window.alert(errors.join(' '))
        }
      })
  }

  const onUpserted = (promise) => {
    promise.then(({ success }) => {
      if (success) {
        setLastChange(+Date.now())
        fetchTemplate()
      }
    })
  }

  return (
    <div className="grow flex h-full w-full overflow-scroll">
      <div className="w-3/4 flex flex-col h-full overflow-scroll">
        <div className="shadow bg-gray-50 w-full px-1 md:px-2 xl:px-4 py-2 xl:py-3 text-xs font-medium text-gray-600 uppercase tracking-wider flex justify-between">
          <span><FormattedMessage{...messages.details}/></span>
        </div>

        <div className="grow overflow-scroll py-12">
          { template ? (
            <Template template={template} id={id} onUpserted={onUpserted} />
          ) : (
            <Loading />
          ) }
        </div>
      </div>
      <div className="w-1/4 h-full flex flex-col border-l border-gray-100">
        <OrderDetailsPane order={{ uid: id }} />
      </div>
    </div>
  )
}

export default UpdatePage
